<template>
  <select
    id="sort_order"
    class="mdb-select md-form mb-0 non-flash-outline sort"
  >
    <option
      v-for="item in optionsList"
      :key="item['key']"
      :value="item['key']"
      :selected="item['key'] === selected"
      :data-icon="item['key'] === selected ? activeCheck : ''"
    >
      {{ item['value'] }}
    </option>
  </select>
</template>

<script>
import * as activeCheck from "../../../assets/images/baseline_check_black_18dp.png";

export default {
  props: {
    optionsList: {
      type: Array,
      default() {
        return [""];
      }
    },
    selected: {
      type: String,
      default: "#"
    },
    formId: {
      type: String,
      default: "form"
    }
  },
  data() {
    return {
      activeCheck
    };
  },
  mounted() {
    $(".mdb-select").materialSelect();
    $("#sort_order").change(() => {
      $(`#${this.formId}`).submit();
    });
  }
};
</script>
